import React from "react";

export default function UnAuthHeader() {
  return (<section className="jumbotron flex flex-column align-items-center justify-content-center">
    <h3 className="company-title inter my-1">Bhrikuti Stock Broking Company</h3>
    <h2 className="page-title inter my-1">Career Portal</h2>
  </section>)
}
